<template>
  <div class="visit-designer-container-9136076486841527" v-if="loadState">
    <div class="content" ref="container" style="display: flex; height: 100%;">
      <aside class="left" :style="{ width: leftWidth + 'px' }">
        <CsimSchemaAttribute
          @handleSelectForm="handleSelectForm"
          @changeFormDesignTab="changeFormDesignTab"
          ref="CsimSchemaAttribute"
          :model="model"
        />
      </aside>
      <div class="split-bar" @mousedown="startDrag">
        <button
          class="collapse-btn"
          @click.stop="toggleCollapseLeft"
          :disabled="collapseState === 'right'"
          :title="collapseState === 'left' ? '回到中间' : '折叠左侧'"
        >
          <span v-if="collapseState === 'left'">&#8596;</span>
          <span v-else>&#8592;</span>
        </button>
        <button
          class="collapse-btn"
          @click.stop="toggleCollapseRight"
          :disabled="collapseState === 'left'"
          :title="collapseState === 'right' ? '回到中间' : '折叠右侧'"
        >
          <span v-if="collapseState === 'right'">&#8596;</span>
          <span v-else>&#8594;</span>
        </button>
      </div>
      <aside class="right" :style="{ width: rightWidth + 'px' }">
        <CsimSchemaPeriod
          ref="CsimSchemaPeriod"
          v-on="$listeners"
          :model="model"
        />
      </aside>
    </div>
  </div>
</template>

<script>
import "./styles/schema-design.less";
import CsimSchemaAttribute from "./module/CsimSchemaAttribute";
import CsimSchemaPeriod from "./module/CsimSchemaPeriod";

export default {
  name: "CsimSchemaDesign_Backup",
  components: {
    CsimSchemaPeriod,
    CsimSchemaAttribute,
  },
  data() {
    return {
      loadState: false,
      model: {
        id: "",
        formList:[],
        keywordList:[],
      },
      selectForm: {},
      leftWidth: 0,
      rightWidth: 0,
      dragging: false,
      startX: 0,
      startWidth: 0,
      startRightWidth: 0,
      lastLeftWidth: 300,
      lastRightWidth: 300,
      containerWidth: 0,
      splitBarWidth: 6,
      collapseState: 'none' // 'none' | 'left' | 'right'
    };
  },
  methods: {
    handleSetSchema(record) {
      this.model = record;

      let that = this;
      this.$nextTick(() => {
        that.$refs.CsimSchemaAttribute.handleSetSchema(record);
        that.$refs.CsimSchemaPeriod.handleSetSchema(record);
      });
    },
    handleSelectForm(record) {
      this.selectForm = record;
    },
    startDrag(e) {
      // 折叠状态禁止拖动
      if (this.collapseState !== 'none') return;
      this.dragging = true;
      this.startX = e.clientX;
      this.startWidth = this.leftWidth;
      this.startRightWidth = this.rightWidth;
      document.addEventListener("mousemove", this.onDrag);
      document.addEventListener("mouseup", this.stopDrag);
    },
    onDrag(e) {
      if (!this.dragging) return;
      const delta = e.clientX - this.startX;
      let newLeft = Math.max(40, Math.min(this.startWidth + delta, this.containerWidth - this.splitBarWidth - 40));
      let newRight = this.containerWidth - newLeft - this.splitBarWidth;
      if (newRight < 40) {
        newRight = 40;
        newLeft = this.containerWidth - this.splitBarWidth - 40;
      }
      this.leftWidth = newLeft;
      this.rightWidth = newRight;
    },
    stopDrag() {
      this.dragging = false;
      document.removeEventListener("mousemove", this.onDrag);
      document.removeEventListener("mouseup", this.stopDrag);
    },
    toggleCollapseLeft() {
      if (this.collapseState === 'left') {
        // 回到居中
        this.leftWidth = Math.floor((this.containerWidth - this.splitBarWidth) / 2);
        this.rightWidth = this.containerWidth - this.leftWidth - this.splitBarWidth;
        this.collapseState = 'none';
      } else if (this.collapseState === 'none') {
        // 折叠左侧
        this.lastLeftWidth = this.leftWidth;
        this.leftWidth = 40;
        this.rightWidth = this.containerWidth - this.leftWidth - this.splitBarWidth;
        this.collapseState = 'left';
      }
    },
    toggleCollapseRight() {
      if (this.collapseState === 'right') {
        // 回到居中
        this.leftWidth = Math.floor((this.containerWidth - this.splitBarWidth) / 2);
        this.rightWidth = this.containerWidth - this.leftWidth - this.splitBarWidth;
        this.collapseState = 'none';
      } else if (this.collapseState === 'none') {
        // 折叠右侧
        this.lastRightWidth = this.rightWidth;
        this.rightWidth = 40;
        this.leftWidth = this.containerWidth - this.rightWidth - this.splitBarWidth;
        this.collapseState = 'right';
      }
    },
    updateWidths() {
      const container = this.$refs.container;
      if (container) {
        this.containerWidth = container.offsetWidth;
        this.leftWidth = Math.floor((this.containerWidth - this.splitBarWidth) / 2);
        this.rightWidth = this.containerWidth - this.leftWidth - this.splitBarWidth;
        this.lastLeftWidth = this.leftWidth;
        this.lastRightWidth = this.rightWidth;
        this.collapseState = 'none';
      }
    },
    changeFormDesignTab(type, formInfo) {
      this.$emit("changeFormDesignTab", type, formInfo);
    }
  },
  created() {
    this.loadState = true;
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.updateWidths();
      }, 0);
      window.addEventListener("resize", this.updateWidths);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateWidths);
  },
  watch: {
    loadState(val) {
      if (val) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.updateWidths();
          }, 0);
        });
      }
    }
  }
};
</script>

<style scoped>
.content {
  height: 100%;
  position: relative;
}
.left {
  background: #f7f7f7;
  height: 100%;
  overflow: auto;
}
.right {
  background: #fff;
  height: 100%;
  overflow: auto;
}
.split-bar {
  width: 6px;
  cursor: ew-resize;
  background: #ddd;
  height: 100%;
  position: relative;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.collapse-btn {
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 14px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.08);
  transition: background 0.2s;
  margin: 2px 0;
}
.collapse-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.collapse-btn:hover:enabled {
  background: #f0f0f0;
}
</style>